var module = angular.module('octopusApp.infrastructure');

module.directive('spin', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      active: '=active'
    },
    templateUrl: 'infrastructure/directives/views/spin.html',
    link: function (scope, element) {

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/spin.js
// module id = 7149270573743511
// module chunks = 1